import { listToStringList } from './mutations';

//add more parameters for fetching other than name
export const getMe = (accessToken) => {
	return {
		query: `query { 
            getMe(accessToken: "${accessToken}"){
                profile{
                    id,
                    dob,
                    firstName, 
                    lastName,
                    gender,
                    city,
                    state,
                    zipCode,
                    country,
                    qualifications,
                    occupation,
                    employedIn,
                    annualIncome,
                    isNri,
                    maritalStatus,
                    motherTongue,
                    religion,
                    caste,
                    gotra,
                    kuldevta,
                    nakshatra,
                    rashi,
                    languagesKnown,
                    bloodGroup,
                    height,
                    weight,
                    foodHabits, 
                    drinkingHabits,
                    smokingHabits,
                    fatherName,
                    fatherNumber,
                    motherName,
                    motherNumber,
                    contactNumber,
                    contactEmail,
                    bio,
                    isImageAvailable,
                    photoKeys,
                    userPreferences,
                    math
                }, 
                favouriteIds,
                user {
                    remainingValidityMillis,
                    filterPreferences,
                    profileReminderTime
                },
                roles,
                reportedUsers,
                acknowledgements {
                    lastTnCVersion,
                    lastDeclarationTime,
                    lastPreviewTime
                }
            }
        }`,
		variables: null,
	};
};

export const getFavouritesQuery = (accessToken, page, perPage, filters = [], searchText = "") => {
	const filterString = filters.length > 0 ? `[${filters.map(f => `\"${f}\"`).join(",")}]` : '[]';
	return {
		query: `query {
      getFavourites(
        accessToken: "${accessToken}",
        query: "${searchText}",
        filters: ${filterString},
        page: ${page},
        perPage: ${perPage}
      ) {
        current_page
        total_pages
        profiles {
          id,
          dob,
          firstName,
          lastName,
          gender,
          city,
          state,
          zipCode,
          country,
          qualifications,
          occupation,
          employedIn,
          annualIncome,
          isNri,
          maritalStatus,
          motherTongue,
          religion,
          caste,
          gotra,
          kuldevta,
          nakshatra,
          rashi,
          languagesKnown,
          bloodGroup,
          height,
          weight,
          foodHabits,
          drinkingHabits,
          smokingHabits,
          fatherName,
          fatherNumber,
          motherName,
          motherNumber,
          contactNumber,
          contactEmail,
          bio,
          isImageAvailable,
          photoKeys,
          userPreferences,
          math
        }
      }
    }`,
		variables: null,
	};
};
//needs access token!!
export const search = (
	accessToken,
	filters,
	pageNumber,
	pageSize,
	searchText
) => {
	const filterString = filters.length > 0 ? listToStringList(filters) : '[]';
	return {
		query: `query { 
            search(accessToken: "${accessToken}", filters: ${filterString}, page: ${pageNumber}, per_page: ${pageSize}, query: "${searchText}"){
                profiles{                    
                    id,
                    dob,
                    firstName, 
                    lastName,
                    gender,
                    city,
                    state,
                    zipCode,
                    country,
                    qualifications,
                    occupation,
                    employedIn,
                    annualIncome,
                    isNri,
                    maritalStatus,
                    motherTongue,
                    religion,
                    caste,
                    gotra,
                    kuldevta,
                    nakshatra,
                    rashi,
                    languagesKnown,
                    bloodGroup,
                    height,
                    weight,
                    foodHabits, 
                    drinkingHabits,
                    smokingHabits,
                    fatherName,
                    fatherNumber,
                    motherName,
                    motherNumber,
                    contactNumber,
                    contactEmail,
                    bio,
                    isImageAvailable,
                    photoKeys
                },
                total_pages
            }
        }`,
		variables: null,
	};
};

export const filter = (accessToken, filters, pageNumber, pageSize) => {
	//how to pass empty filters
	const filterString = filters.length > 0 ? listToStringList(filters) : '[]';
	// console.log('creating filter query', { filters, filterString });
	return {
		query: `query { 
            filter(accessToken: "${accessToken}", filters: ${filterString}, page: ${pageNumber}, per_page: ${pageSize}){
                profiles{                    
                    id,
                    dob,
                    firstName, 
                    lastName,
                    gender,
                    city,
                    state,
                    zipCode,
                    country,
                    qualifications,
                    occupation,
                    employedIn,
                    annualIncome,
                    isNri,
                    maritalStatus,
                    motherTongue,
                    religion,
                    caste,
                    gotra,
                    kuldevta,
                    nakshatra,
                    rashi,
                    languagesKnown,
                    bloodGroup,
                    height,
                    weight,
                    foodHabits, 
                    drinkingHabits,
                    smokingHabits,
                    fatherName,
                    fatherNumber,
                    motherName,
                    motherNumber,
                    contactNumber,
                    contactEmail,
                    bio,
                    isImageAvailable,
                    photoKeys
                },
                total_pages
            }
        }`,
		variables: null,
	};
};

export const getUploadDataQuery = (accessToken) => {
	return {
		query: `query {getUploadData(accessToken: "${accessToken}"){key,url,formFields}}`,
		variables: null,
	};
};

export const adminGetUploadDataForProfileQuery = (accessToken, userId) => {
	return {
		query: `query {adminGetUploadDataForProfile(accessToken: "${accessToken}", userId: "${userId}"){key,url,formFields}}`,
		variables: null,
	};
};

export const getLatestConfigQuery = () => {
    return {
        query: `query {
            getLatestConfigs {
                latestTnCVersion,
                latestIntroVersion,
                tncContent
            }
        }`,
        variables: null,
    };    
}

export const adminViewProfileQuery = (
	accessToken,
	filters,
	pageNumber,
	pageSize
) => {
	const filterString = filters.length > 0 ? listToStringList(filters) : '[]';
	return {
		query: `query { 
            adminFilter(accessToken: "${accessToken}", filters: ${filterString}, page: ${pageNumber}, per_page: ${pageSize}){
                users{
                    id,
                    profile{
                        id,
                        dob,
                        firstName, 
                        lastName,
                        gender,
                        city,
                        state,
                        zipCode,
                        country,
                        qualifications,
                        occupation,
                        employedIn,
                        annualIncome,
                        isNri,
                        maritalStatus,
                        motherTongue,
                        religion,
                        caste,
                        gotra,
                        kuldevta,
                        nakshatra,
                        rashi,
                        languagesKnown,
                        bloodGroup,
                        height,
                        weight,
                        foodHabits, 
                        drinkingHabits,
                        smokingHabits,
                        fatherName,
                        fatherNumber,
                        motherName,
                        motherNumber,
                        contactNumber,
                        contactEmail,
                        bio, 
                        isImageAvailable,
                        photoKeys,
                        disabled,
                        bio, 
                        userPreferences,
                        math
                    },
                    user {
                      phone, 
                      email,
                      disabled,
                      remainingValidityMillis  
                    }
                }
            }
        }`,
		variables: null,
	};
};

export const adminFilterQuery = (
	accessToken,
	filters,
	pageNumber,
	pageSize
) => {
	const filterString = filters.length > 0 ? listToStringList(filters) : '[]';
	return {
		query: `query { 
            adminFilter(accessToken: "${accessToken}", filters: ${filterString}, page: ${pageNumber}, per_page: ${pageSize}){
                users{
                    id,
                    profile{
                        id,
                        dob,
                        firstName, 
                        lastName,
                        gender,
                        city,
                        state,
                        country,
                        contactNumber,
                        contactEmail,
                        bio,
                        isImageAvailable,
                        photoKeys,
                        disabled,
                        gotra,
                        kuldevta,
                        userPreferences,
                        math
                    },
                    user {
                      phone, 
                      email,
                      disabled,
                      remainingValidityMillis  
                    }
                },
                total_pages
            }
        }`,
		variables: null,
	};
};

export const adminSearchQuery = (
	accessToken,
	filters,
	pageNumber,
	pageSize,
	searchText
) => {
	const filterString = filters.length > 0 ? listToStringList(filters) : '[]';
	return {
		query: `query { 
            adminSearch(accessToken: "${accessToken}", filters: ${filterString}, page: ${pageNumber}, per_page: ${pageSize}, query:"${searchText}"){
                users{
                    id,
                    profile{
                        id,
                        dob,
                        firstName, 
                        lastName,
                        gender,
                        city,
                        state,
                        country,
                        contactNumber,
                        contactEmail,
                        bio,
                        isImageAvailable,
                        photoKeys,
                        disabled,
                        gotra,
                        kuldevta,
                        userPreferences,
                        math
                    },
                    user {
                      phone, 
                      email,
                      disabled,
                      remainingValidityMillis  
                    }
                },
                total_pages
            }
        }`,
		variables: null,
	};
};


export const adminGetAllOpenReportsQuery = (token, pageNumber, pageSize, isOpen = true) => {
	return {
		query: `query {
			adminGetAllReports (accessToken:"${token}", 
				page:${pageNumber}, 
				per_page:${pageSize},
                is_open:${isOpen}
			) {
                reports{
                    reporterID,
                    reporterName,
                    reporterContactNumber,
                    reporterContactEmail,
                    reportedProfileID,
                    reportedProfileName,
                    reportedProfileContactEmail,
                    reportedProfileContactNumber,
                    reportedTime,
                    reporterComment
                },
                totalPages
			}
		}`,
		variables: null,
	};
};

export const adminGetProfileByPhoneQuery = (accessToken, phone) => {
    return {
      query: `query {
        adminGetProfileByPhone(accessToken: "${accessToken}", phone: "${phone}") {
          id,
          user {
            phone,
            email,
            disabled,
            remainingValidityMillis  
          },
          profile {
            id,
            dob,
            firstName, 
            lastName,
            gender,
            city,
            state,
            country,
            contactNumber,
            contactEmail,
            bio,
            isImageAvailable,
            photoKeys,
            disabled
          }
        }
      }`,
      variables: null,
    };
  };
  
  export const adminGetProfileByEmailQuery = (accessToken, email) => {
    return {
        query: `query {
          adminGetProfileByEmail(accessToken: "${accessToken}", email: "${email}") {
            id,
            user {
              id,
              phone,
              email,
              disabled,
              remainingValidityMillis,
              adminComments
            },
            profile {
              id,
              firstName,
              lastName,
              dob,
              gender,
              city,
              state,
              zipCode,
              country,
              qualifications,
              occupation,
              employedIn,
              annualIncome,
              isNri,
              maritalStatus,
              motherTongue,
              religion,
              caste,
              gotra,
              nakshatra,
              kuldevta,
              rashi,
              languagesKnown,
              bloodGroup,
              height,
              weight,
              foodHabits,
              drinkingHabits,
              smokingHabits,
              fatherName,
              fatherNumber,
              motherName,
              motherNumber,
              contactNumber,
              contactEmail,
              bio,
              isImageAvailable,
              photoKeys,
              disabled
            }
          }
        }`,
        variables: null,
    };
};

export const getProfileByIdQuery = (accessToken, id) => {
  return {
    query: `query {
      getProfileById(accessToken: "${accessToken}", id: "${id}") {
        Profile {
            id,
            dob,
            firstName, 
            lastName,
            gender,
            city,
            state,
            zipCode,
            country,
            qualifications,
            occupation,
            employedIn,
            annualIncome,
            isNri,
            maritalStatus,
            motherTongue,
            religion,
            caste,
            gotra,
            kuldevta,
            nakshatra,
            rashi,
            languagesKnown,
            bloodGroup,
            height,
            weight,
            foodHabits, 
            drinkingHabits,
            smokingHabits,
            fatherName,
            fatherNumber,
            motherName,
            motherNumber,
            contactNumber,
            contactEmail,
            bio,
            isImageAvailable,
            photoKeys,
            userPreferences,
            math
        }
        NeedPayment
      }
    }`,
    variables: null,
  };
};

export const getPreviewProfilesQuery = (accessToken) => {
  return {
    query: `query {
      getPreviewProfiles(accessToken: "${accessToken}") {
        id,
        dob,
        firstName, 
        lastName,
        gender,
        city,
        state,
        zipCode,
        country,
        qualifications,
        occupation,
        employedIn,
        annualIncome,
        isNri,
        maritalStatus,
        motherTongue,
        religion,
        caste,
        gotra,
        kuldevta,
        nakshatra,
        rashi,
        languagesKnown,
        bloodGroup,
        height,
        weight,
        foodHabits, 
        drinkingHabits,
        smokingHabits,
        fatherName,
        fatherNumber,
        motherName,
        motherNumber,
        contactNumber,
        contactEmail,
        bio,
        isImageAvailable,
        photoKeys
      }
    }`,
    variables: null,
  };
};
